/* 黃月英（諸葛亮之妻） */
import { defineHero, P, D } from '../define.ts';

export default defineHero({
  id: 'huangyueying', name: '黃月英', sub: '諸葛亮之妻', faction: 'shu', role: '射手', weapon: 'staff',
  look: { female: true, head: 'bun', hair: '#5a3a2a', robe: true, size: 0.96, statAdj: { base: [-3, 0, 0], grow: [-0.3, 0, 0] }, fx: '#f3d27a', c: { cloth: '#5a8a5c', sleeve: '#5a8a5c', armor: '#e9c46a', flower: '#f3d27a', pole: '#6b4a2a' } },
  skills: [
    ['散華', 'bolt', '朝方向扇形擲出三枝長槍，各自穿透敵人，造成 {75/150/225/275} 傷害。', { x: { k: 'line', n: 3, fan: 0.22, dmg: [75, 150, 225, 275], rad: 26, speed: 1000, shape: 'arrow', fromCast: true }, aim: D(720, 26), cd: [14, 13, 12, 11], mp: [100, 110, 120, 130] }], // v0.4.2：原本以自己為中心的圓形範圍
    ['狂氣', 'buff', '攻速 +{40/60/80/100}%，持續 15 秒。', { x: { k: 'buff', as: [40, 60, 80, 100], dur: 15 }, cd: 50, mp: 125, el: 'wind' }],
    ['閃光', 'blink', '瞬間移動一大段距離，無視地形。冷卻 {19/16/13/10} 秒（依本作節奏縮短）。', { x: { k: 'blink' }, aim: P(600, 0), cd: [19, 16, 13, 10], mp: 40, el: 'holy' }],
    ['鳳穿', 'buff', '60 秒內普攻會同時射向另外 {2/3/4} 個敵人（額外的箭 50% 傷害）。', { x: { k: 'buff', multi: [3, 4, 5], dur: 60 }, cd: 130, mp: 150 }],
  ],
});
